import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';

type FeatureFlagsState = {
  disableDiagnostics: boolean;
  disableDeveloper: boolean;
};

const initialState: FeatureFlagsState = {
  disableDiagnostics: false,
  disableDeveloper: false,
};

export const featureFlagsSlice = createSlice({
  name: 'featureFlags',
  initialState,
  reducers: {
    setDisableDiagnostics: (state, action: PayloadAction<boolean>) => {
      state.disableDiagnostics = action.payload;
    },
    setDisableDeveloper: (state, action: PayloadAction<boolean>) => {
      state.disableDeveloper = action.payload;
    },
  },
});

export const { setDisableDiagnostics, setDisableDeveloper } =
  featureFlagsSlice.actions;

export const selectDisableDiagnostics = (state: RootState) =>
  state.featureFlags.disableDiagnostics;

export const selectDisableDeveloper = (state: RootState) =>
  state.featureFlags.disableDeveloper;
